/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getListCategory(card: any): any[] {
    try {
        return Object.entries(card.workflow)
            .sort((a: any, b: any) =>
                a[1]
                    ? a[1]?.rank
                        ? b[1]?.rank
                            ? a[1]?.rank - b[1]?.rank
                            : -1
                        : 1
                    : 1
            )

            .reduce((prev: any, [uid]: any) => {
                if (
                    card.categories[uid] &&
                    !card.categories[uid].archive &&
                    isVisibleKiosk(card.categories[uid].KioskVisibility)
                ) {
                    const isNameDisplayed =
                        card.categories[uid]?.isNameShow !== undefined
                            ? card.categories[uid]?.isNameShow
                            : true;
                    return [
                        ...prev,
                        {
                            iuud: uid,

                            isNameDisplayed,
                            title: card.categories[uid].displayName.dflt.nameDef
                                ? card.categories[uid].displayName.dflt.nameDef
                                : card.categories[uid].title,
                            type: "categories",
                            image: card.categories[uid].img.dflt.img
                                ? card.categories[uid].img.dflt.img
                                : "nopicture.png",
                            video: card.categories[uid].video,
                            visibilityInfo: card.categories[uid].visibilityInfo,
                            tagsItems: [
                                ...new Set(card.categories[uid].tagList),
                            ],
                            KioskVisibility:
                                card.categories[uid].KioskVisibility,
                            isInformationModeActivated:
                                card.categories[uid]
                                    ?.isInformationModeActivated !== undefined
                                    ? card.categories[uid]
                                          ?.isInformationModeActivated
                                    : true,

                            name: card.categories[uid]?.name,
                            design: card.workflow[uid]?.design,
                            url_image: {
                                default:
                                    card.categories[uid].img.dflt.img ??
                                    "nopicture.png",
                            },
                        },
                    ];
                } else {
                    return [...prev];
                }
            }, []);
    } catch (error) {
        return [];
    }
}
function isVisibleKiosk(KioskVisibility: KioskVisibility) {
    return Object.values(KioskVisibility).some((value) => value === true);
}
